import { API } from "./http.service";

/**
 * Portal asistanı (chatbot) servis çağrıları.
 *
 * Yapay zeka istekleri doğrudan Anthropic'e DEĞİL, backend (support-service)
 * üzerinden gider. API anahtarı backend'de application.yml içinde tutulur,
 * istemciye hiçbir zaman açılmaz. Gateway `/support/**` yolunu support-service'e
 * yönlendirir; bu yüzden uç nokta `/support/ai/chat`'tir.
 *
 * @param {Array<{role: 'user'|'assistant', content: string}>} messages konuşma geçmişi
 * @returns {Promise} http.service tarafından normalize edilmiş yanıt ({ reply, isHttpSuccess })
 */
export const sendAssistantMessage = (messages) =>
  API.post("/support/ai/chat", { messages });
